import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MasterService } from '../../master/services/master-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonHelper } from '../../../helper/helper.component';
import { CommonConstants } from '../../../shared/constants';
import { DatePipe } from '@angular/common';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-complaints-summary-reports',
  templateUrl: './complaints-summary-reports.component.html',
  styleUrls: ['./complaints-summary-reports.component.scss'],
  providers: [MasterService, NgxSpinnerService, CommonHelper, DatePipe]

})
export class ComplaintsSummaryReportsComponent implements OnInit {
  selectedState: any;
  statesData: any;
  categories: any;
  errorOrResponse = false;
  emptyDataCheck: boolean = false;
  reportsComplainSummaryData: any = [];
  filterForm: FormGroup;
  submitted: boolean = false;
  showPickerStart = false;
  startDateTime: any;
  dataTable: any;
  maxDate = new Date();
  showDateStart = true;
  showTimeStart = true;
  closeButtonStart: any = { show: true, label: 'Close Me!', cssClass: 'btn btn-sm btn-primary' };
  showPickerEnd = false;
  endDateTime: any;
  showDateEnd = true;
  showTimeEnd = true;
  inc: number = 0;
  closeButtonEnd: any = { show: true, label: 'Close Me!', cssClass: 'btn btn-sm btn-primary' };

  constructor(
    private masterService: MasterService,
    private spinner: NgxSpinnerService,
    private commonHelper: CommonHelper,
    private fb: FormBuilder,
    private datepipe: DatePipe,
    private chRef: ChangeDetectorRef
  ) {
    this.endDateTime = this.datepipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss");
    this.startDateTime = this.datepipe.transform(new Date(), "yyyy-MM-dd 00:00:00");
  }


  ngOnInit() {
    this.getStates();
    this.filterDefaultValues();
    this.emptyDataCheck = false;
  }

  filterDefaultValues() {
    this.filterForm = this.fb.group({
      selectedState: [],
      selectedGrievaceType: [],
      startDateTime: [''],
      endDateTime: [''],
    });
  }

  /** getStates
   * 
   * @param isStates 
   */
  getStates() {
    try {
      this.spinner.show();
      this.errorOrResponse = false;
      this.masterService.getAll('active_states').subscribe((response: any) => {
        if (response.status) {
          if (response.data.length > 0) {
            this.spinner.hide();
            this.errorOrResponse = true;
            this.statesData = response.data;
          } else {
            this.spinner.hide();
            this.errorOrResponse = true;
          }
        }
      }, error => {
        this.spinner.hide();
        this.errorOrResponse = true;
      });
    } catch (excp) {
      this.spinner.hide();
    }
    setTimeout(() => {
      this.spinner.hide();
      if (this.errorOrResponse == false) {
        this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
      }
    }, 40000)
  }

  /**GetDistricts
     * 
     * @param stateId 
     */
  getCategories(stateId: number) {
    this.apiCalling('grievance_type', stateId);
  }

  apiCalling(url: string, id: number) {
    try {
      this.spinner.show();
      this.masterService.getData(url + '/', id).subscribe((response: any) => {
        if (response.status) {
          this.getDataBinding(url, response);
        } else {
          this.spinner.hide();
        }
      }, error => {
        this.spinner.hide();
      });
    } catch (excp) {
      this.spinner.hide();
    }
  }

  getDataBinding(url: string, response: any) {
    if (url === 'grievance_type') {
      this.filterForm.get('selectedGrievaceType').setValue([]);
      if (response.data[0].grievanceType.length > 0) {
        this.spinner.hide();
        this.chRef.detectChanges();
        this.categories = response.data[0].grievanceType;
      } else {
        this.categories = [];
        this.spinner.hide();
      }
    }
  }

  /**
  * state change
  * @param event 
  */
  onStateChange(event: any) {
    if (event) {
      this.getCategories(event.id);
    }
  }

  // toggle function to show datetime picker modal
  onTogglePicker(value: string) {
    if (value == 'startDT') {
      if (!this.showPickerStart) {
        this.showPickerStart = true;

      }
    }
    if (value == 'endDT') {
      if (!this.showPickerEnd) {
        this.showPickerEnd = true;
      }
    }
  }
  // function to append value in input 
  onValueChange(val: any, endorstart: string) {
    if (endorstart === 'startDT') {
      val = this.datepipe.transform(val, "yyyy-MM-dd HH:mm:ss")
      this.startDateTime = val;
      this.submitted = false;
    }
    if (endorstart === 'endDT') {
      val = this.datepipe.transform(val, "yyyy-MM-dd HH:mm:ss")
      this.endDateTime = val;
      this.submitted = false;
    }
  }
  /**getReports
     * 
     */
  getReports(param: string) {
    let apiData = this.filterForm.value, data: any,
      grievanceTypeId: any, endDatetime: any, startDatetime: any;
    grievanceTypeId = apiData.selectedGrievaceType ? apiData.selectedGrievaceType.grievanceTypeId : '';
    startDatetime = this.startDateTime ? this.startDateTime : '';
    endDatetime = this.endDateTime ? this.endDateTime : '';
    grievanceTypeId = !grievanceTypeId ? '' : grievanceTypeId

    data = {
      grievanceTypeId: grievanceTypeId,
      startDate: startDatetime,
      endDate: endDatetime
    }
    this.apiCallForPostData("reports/complaints/summary", data, param);
  }

  /**
   * 
   * @param url 
   * @param data 
   */
  apiCallForPostData(url: string, data: any, param: string) {
    this.spinner.show();
    this.errorOrResponse = false;
    this.masterService.postData(url, data).subscribe((response: any) => {
      if (response.status) {
        if (url === 'reports/complaints/summary') {
          if (response.data.length > 0) {
            this.spinner.hide();
            this.postDataBinding(response, param);
            this.errorOrResponse = true;
          } else {
            this.spinner.hide();
            this.emptyDataCheck = false;
            this.reportsComplainSummaryData = [];
            this.commonHelper.toasterMessageError(CommonConstants.noResultFound);
            this.errorOrResponse = true;
          }
        }
      } else {
        this.errorOrResponse = true;
        this.commonHelper.toasterMessageError(CommonConstants.validationMessage)
      }
    }, error => {
      this.spinner.hide();
      this.errorOrResponse = true;
      this.emptyDataCheck = false;
      this.reportsComplainSummaryData = [];
    });
    setTimeout(() => {
      this.spinner.hide();
      if (this.errorOrResponse == false) {
        this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
      }
    }, 40000)
  }

  postDataBinding(response: any, param: string) {
    let newResponse = [];
    this.emptyDataCheck = true;
    this.errorOrResponse = true;
    if (response.data.length > 0) {
      newResponse = response.data;
      if (param === 'isExcel' || param === 'isPdf') {
        this.reportData(newResponse, param);
      } else {
        this.reportsComplainSummaryData = newResponse;
      }
    } else {
      this.reportsComplainSummaryData = [];
      this.spinner.hide();
      this.emptyDataCheck = false;
      this.errorOrResponse = true;
      this.commonHelper.toasterMessageError(CommonConstants.noResultFound);
    }
  }

  /**
     * 
     * @param rData 
     * @param param 
     */
  reportData(rData: any, param: any) {
    let data = [];
    rData.filter((newResponse: any) => {
      data.push({
        complaintDate: newResponse.complaintDate != null ? newResponse.complaintDate:'',
        complaintId: newResponse.complaintId != null ? newResponse.complaintId:'',
        complaintName: newResponse.complainant_name != null ? newResponse.complainant_name:'',
        gender: newResponse.gender != null ? newResponse.gender:'',
        fatherorHusbandName: newResponse.father_or_husband_name != null ? newResponse.father_or_husband_name:'',
        phoneNumber: newResponse.phoneNumber != null ? newResponse.phoneNumber:'',
        briefComplaint: newResponse.briefComplaint != null ? newResponse.briefComplaint:'',
        detailsOfComplaint: newResponse.detailsOfComplaint !=null? newResponse.detailsOfComplaint: '',
        grievanceType: newResponse.grievanceType != null ? newResponse.grievanceType:'',
        grievanceTypeId: newResponse.grievanceTypeId != null ? newResponse.grievanceTypeId:'',
        severity: newResponse.severity != null?newResponse.severity : '',
        natureOfComplaint: newResponse.natureOfComplaint != null ? newResponse.natureOfComplaint:'',
        complaintNatureId: newResponse.grievanceNatureId != null ? newResponse.grievanceNatureId:'',
        ishelpdone: newResponse.is_medical_help_arrived != null ? newResponse.is_medical_help_arrived:'',
        statesName: newResponse.statesName != null ? newResponse.statesName:'',
        statesId: newResponse.stateId != null ? newResponse.stateId:'',
        districtName: newResponse.districtName != null ? newResponse.districtName:'',
        districtId: newResponse.districtId != null ? newResponse.districtId:'',
        talukaName: newResponse.talukaName != null ? newResponse.talukaName:'',
        talukaId: newResponse.talukaId != null ? newResponse.talukaId:'',
        villageName: newResponse.villageName != null ? newResponse.villageName:'',
        villageId: newResponse.villageId != null ? newResponse.villageId:'',
        complaintAgainstInstitution: newResponse.complaintAgainstInstitution != null ? newResponse.complaintAgainstInstitution:'',
        complaintAgainstWhom: newResponse.complaintAgainstWhom != null ? newResponse.complaintAgainstWhom:'',
        designationName: newResponse.designationName != null ? newResponse.designationName:'',
        designationId: newResponse.designationId != null ? newResponse.designationId:'',
        areaType: newResponse.area_type != null ? newResponse.area_type:'',
        grClosedUser: newResponse.grClosedUser != null ? newResponse.grClosedUser:'',
        actions: newResponse.actions != null ? newResponse.actions:'',
        resolvedActions: newResponse.resolvedActions != null ? newResponse.resolvedActions:'',
        status: newResponse.status != null ? newResponse.status:'',
      });
    });
    let options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      headers: ['Grievance Date', 'Grievance ID', 'ComplaintName', 'Gender', 'Father or Husband Name', 
      'Phone Number', 'Brief Grievance', 'Details of Grievance', 'Grievance Type', 'Grievance Type Id', 
      'Severity', 'Nature of Grievance', 'Complaint Nature Id', 'Is Help Done', 'State', 'State Id', 'District', 
      'District Id', 'Tehsil', 'Tehsil Id', 'Village', 'Village Id', 'Grievance Against Institution', 
      'Grievance Against Whom', 'Designation', 'Designation Id', 'Area Type', "Grievance Closed By", 
      "Actions", "resolved Actions", 'Status']
    };
    if (param === 'isExcel') {
      this.exportToExcel(data, options);
    } else {
      this.exportToPdf(data);
    }
  }

  /**export to excel
   * 
   * @param data 
   * @param options 
   */
  exportToExcel(data: any, options: any) {
    new Angular5Csv(data, CommonConstants.complaintSummaryWiseReport, options);
  }

  /**
   * 
   * @param data 
   */
  exportToPdf(data: any) {
    let doc = new jsPDF('l', 'pt', 'a2'),
      col = ["Sr. No.", "Grievance Date", "Grievance ID", 'ComplaintName', 'Gender', 'Father or Husband Name', 
      "Phone Number", "Brief Grievance", "Details", 'Grievance Type', 'Grievance Type Id', 'Severity', 
      "Nature of Grievance", 'Complaint Nature Id', 'Is Help Done', 'State', 'State Id', "District", 'District Id',
       "Tehsil",'Tehsil Id', 'Village', 'Village Id', "Grievance Against Institution", "Grievance Against Whom",
        "Designation", 'Designation Id', 'Area Type', "Grievance Closed By", "Actions", "Resolved Actions", "Status"],
      rows = [];
    var header = function (data) {
      doc.setFontSize(15);
      doc.setTextColor(40);
      doc.setFontStyle('normal');
    
      
      doc.text("Grievance Summary Report", 220, 20);
    };
    data.filter((element: any, index: number) => {
      let temp = [index + 1, element.complaintDate, element.complaintId, element.complaintName, element.gender,
        element.fatherorHusbandName, element.phoneNumber, element.briefComplaint, element.detailsOfComplaint, 
        element.grievanceType, element.grievanceTypeId, element.severity, element.natureOfComplaint, 
        element.complaintNatureId, element.ishelpdone, element.statesName, element.statesId, element.districtName, element.districtId, 
        element.talukaName, element.talukaId, element.villageName, element.villageId, element.complaintAgainstInstitution,
        element.complaintAgainstWhom, element.designationName, element.designationId, element.areaType, element.grClosedUser,
        element.actions, element.resolvedActions, element.status];
      rows.push(temp);
    });

    doc.autoTable(col, rows, {
      theme: 'grid',
      startY: 32,
      margin: {
        right: 20,
        left: 10
      },
      
      addPageContent: header,
      styles: {
        cellPadding: 0.4,
        fontSize: 8,
        lineWidth:1,
        overflow: 'linebreak',
        valign: 'middle',
        halign: 'center',
        tableWidth: 'auto'
      },
      html: document.getElementById('dataTable1'),
      columnStyles: {
        0: { columnWidth:'auto'},
        1: { columnWidth:50 },
        2: { columnWidth:'auto'},
        3: { columnWidth:'auto'},
        4: { columnWidth:30},
        5: { columnWidth:'auto'},
        6: { columnWidth:50},
        7: { columnWidth:100},
        8: { columnWidth:35},
        9: { columnWidth:'auto'},
        10: { columnWidth:'auto'},
        11: { columnWidth:40},
        12: { columnWidth:'auto'},
        13: { columnWidth:'auto'},
        14: { columnWidth:'auto'},
        15: { columnWidth:35},
        16: { columnWidth:'auto' },
        17: { columnWidth:'auto'},
        18: { columnWidth:'auto'},
        19: { columnWidth:'auto'},
        20: { columnWidth:'auto'},
        21: { columnWidth:'auto'},
        22: { columnWidth:'auto'},
        23: { columnWidth:'auto'},
        24: { columnWidth:'auto'},
        25: { columnWidth:'auto'},
        26: { columnWidth:'auto'},
        27: { columnWidth:'auto'},
        28: { columnWidth:35},
        29: { columnWidth:55},
        30: { columnWidth:55},
      },
      drawCell: function (cell: any, data: any) {
        if (data.column.dataKey === 'price' || data.column.dataKey === 'qty' || data.column.dataKey === 'price') {
          cell.styles.halign = 'right';
        }
      }
    });
    doc.save(CommonConstants.complaintSummaryWiseReport + '.pdf');
  }

  /**downloadExcel
   * 
   */
  downloadExcel() {
    this.getReports('isExcel');
  }

  /**downloadPdf
   * 
   */
  downloadPdf() {
    this.getReports('isPdf')
  }

  /**submitReport
   * 
   */
  submitReport() {
    let sDate = this.datepipe.transform(this.startDateTime, "yyyy-MM-dd HH:mm:ss"),
      eDate = this.datepipe.transform(this.endDateTime, "yyyy-MM-dd HH:mm:ss");
    if (sDate) {
      if (eDate) {
        if (sDate >= eDate) {
          this.submitted = true;
          this.emptyDataCheck = false;
        } else {
          this.submitted = false;
          this.getReports('');
        }
      } else {
        this.submitted = false;
        this.getReports('')
      }
    } else {
      this.submitted = false;
      this.getReports('')
    }
  }
}
